import { render } from "./Komponen.vue?vue&type=template&id=7ccfbf88"
import script from "./Komponen.vue?vue&type=script&lang=js"
export * from "./Komponen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__